/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export const ALL = '*';

export const DIV = 'div';
export const MAIN = 'main';
export const ASIDE = 'aside';

export const A = 'a';
export const SPAN = 'span';

export const BUTTON = 'button';

export const OL = 'ol';
export const UL = 'ul';
export const LI = 'li';

export const SVG = 'svg';
export const G = 'g';

export const PATH = 'path';
export const POLYGON = 'polygon';
export const POLYLINE = 'polyline';

export const LINE = 'line';
export const RECT = 'rect';
export const CIRCLE = 'circle';
export const ELLIPSE = 'ellipse';
export const TEXT = 'text';


const ATTRIBUTES =
{
  'aria-describedby': [ALL], // TODO probably needs way more aria attributes pass-through! 'aria-*' should be used to match ?

  id: [ALL],
  slot: [ALL],
  tabindex: [ALL],

  style: [ALL],
  className: [ALL],

  href: [A],

  type: [BUTTON],
  disabled: [BUTTON],

  viewBox: [SVG],
  preserveAspectRatio: [SVG],

  d: [PATH],
  points: [POLYGON, POLYLINE],

  x: [SVG, RECT, TEXT],
  y: [SVG, RECT, TEXT],
  width: [SVG, RECT],
  height: [SVG, RECT],

  x1: [LINE],
  x2: [LINE],
  y1: [LINE],
  y2: [LINE],

  cx: [CIRCLE, ELLIPSE],
  cy: [CIRCLE, ELLIPSE],

  r: [CIRCLE],
  rx: [RECT, ELLIPSE],
  ry: [RECT, ELLIPSE],

  textAnchor: [TEXT],
  dominantBaseline: [TEXT],

  mask: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  filter: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  transform: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  clipPath: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  clipRule: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  color: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  colorInterpolation: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  colorRendering: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  fill: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  fillOpacity: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  fillRule: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  stroke: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  strokeDasharray: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  strokeDashoffset: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  strokeLinecap: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  strokeLinejoin: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  strokeMiterlimit: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  strokeOpacity: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  strokeWidth: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  opacity: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  shapeRendering: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  vectorEffect: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  display: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],
  visibility: [SVG, G, PATH, POLYGON, POLYLINE, LINE, RECT, CIRCLE, ELLIPSE, TEXT],

  onFocus: [ALL],
  onBlur: [ALL],

  onKeyDown: [ALL],
  onKeyPress: [ALL],
  onKeyUp: [ALL],

  onClick: [ALL],
  onDoubleClick: [ALL],

  onMouseDown: [ALL],
  onMouseUp: [ALL],

  onMouseEnter: [ALL],
  onMouseMove: [ALL],
  onMouseLeave: [ALL],

  onTouchStart: [ALL],
  onTouchEnd: [ALL],

  onPointerDown: [ALL],
  onPointerUp: [ALL],

  onPointerEnter: [ALL],
  onPointerMove: [ALL],
  onPointerLeave: [ALL],

  onAnimationStart: [ALL],
  onAnimationCancel: [ALL],
  onAnimationEnd: [ALL],

  onTransitionStart: [ALL],
  onTransitionCancel: [ALL],
  onTransitionEnd: [ALL],
};


export default (type) =>
{
  let attributes = {};

  for (let name in ATTRIBUTES)
  {
    if (ATTRIBUTES[name].includes('*') || ATTRIBUTES[name].includes(type))
    {
      attributes[name] = true;
    }
  }

  return attributes;
}
